









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/compte/edit/EditAdresse.vue'
import { getDefaultAloUser, AloUser } from '@/models/alo/AloUser';

@Component({
  name: 'ReadAdresse',    
   props: {
    user:{      
      default:getDefaultAloUser()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadAdresse extends Vue {
  private user!:AloUser
  private loading!:boolean


  get configuration(){    
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.user) }
}
